import { Request } from './GenerateImageDrawer'

export const incompleteRequests = (requests: Request[]) => {
  return requests.filter((request) => !request.generatedContent && !request.isFailed)
}
